function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { Component } from "react";
import { utils } from "zebulon-controls";
import { computeMetaPositions } from "./utils/compute.meta";
import { rollback } from "./utils/utils";

export var TableMenu = function (_Component) {
    _inherits(TableMenu, _Component);

    function TableMenu() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, TableMenu);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TableMenu.__proto__ || Object.getPrototypeOf(TableMenu)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickMenu = function (props, item) {
            if (props.menu === "column-header-menu") {
                var column = props.column;
                var _this$state = _this.state,
                    data = _this$state.data,
                    meta = _this$state.meta,
                    params = _this$state.params,
                    scroll = _this$state.scroll;

                if (item.id <= 1) {
                    if (!utils.isNullOrUndefined(meta.lockedIndex)) {
                        meta.properties[meta.lockedIndex].locked = false;
                    }
                    if (item.id) {
                        meta.properties[column.index_].locked = true;
                    }
                    computeMetaPositions(meta);
                    _this.setState({
                        scroll: Object.assign({}, scroll, {
                            columns: {
                                direction: 1,
                                index: 0,
                                position: 0,
                                shift: 0,
                                startIndex: 0
                            }
                        })
                    });
                } else {
                    item.function({ data: data, meta: meta, params: params, column: column });
                }
            } else if (props.menu === "row-header-menu") {
                var row = props.row,
                    status = props.status;
                var _this$state2 = _this.state,
                    _data = _this$state2.data,
                    _meta = _this$state2.meta,
                    _params = _this$state2.params,
                    updatedRows = _this$state2.updatedRows;

                if (item.id === 0) {
                    rollback(updatedRows, row.index_);
                    _this.setState({ scroll: _this.state.scroll });
                } else if (item.id === 1) {
                    var audits = _meta.row.auditFunction({ row: row });
                    var prevScroll = _this.state.scroll;
                    var prevRange = _this.state.selectedRange;
                    var columns = props.meta && props.meta.visibleIndexes ? props.meta.visibleIndexes[0] : 0;
                    var selectedRange = {
                        start: { rows: 0, columns: columns },
                        end: { rows: 0, columns: columns }
                    };

                    var _scroll = {
                        rows: {
                            index: 0,
                            direction: 1,
                            startIndex: 0,
                            shift: 0,
                            position: 0
                        },
                        columns: {
                            index: 0,
                            direction: 1,
                            startIndex: 0,
                            shift: 0,
                            position: 0
                        }
                    };
                    if (utils.isPromise(audits)) {
                        audits.then(function (audits) {
                            _this.setState({
                                auditedRow: row,
                                audits: audits || [],
                                scroll: _scroll,
                                prevScroll: prevScroll,
                                selectedRange: selectedRange,
                                prevRange: prevRange
                            });
                            // }
                        });
                    } else {
                        // if (audits)
                        var _scroll2 = _this.state.prevScroll;
                        _this.setState({
                            auditedRow: row,
                            audits: audits || [],
                            scroll: _scroll2,
                            prevScroll: prevScroll,
                            selectedRange: selectedRange,
                            prevRange: prevRange
                        });
                    }
                } else {
                    item.function({ data: _data, meta: _meta, params: _params, row: row, status: status });
                }
            } else if (props.menu === "top-left-corner-menu") {
                var _this$state3 = _this.state,
                    filters = _this$state3.filters,
                    _data2 = _this$state3.data,
                    _meta2 = _this$state3.meta,
                    _params2 = _this$state3.params,
                    _updatedRows = _this$state3.updatedRows;

                var filter = filters.status_;
                if (!filter) {
                    filter = { id: "status_", v: 0 };
                }
                var v = item.id % 100;
                if (filter.v & v) {
                    filter.v -= v;
                } else {
                    filter.v += v;
                }
                if (item.id === 2) {
                    var _scroll3 = _this.state.prevScroll;
                    var _selectedRange = _this.state.prevRange;
                    computeMetaPositions(_meta2);
                    _this.setState({
                        auditedRow: undefined,
                        audits: undefined,
                        scroll: _scroll3,
                        prevScroll: undefined,
                        selectedRange: _selectedRange,
                        prevRange: undefined
                    });
                } else if (item.id === 0 || item.id >= 100 && item.id < 104) {
                    if (item.id === 0 || filter.v === 0) {
                        delete filters.status_;
                    } else if (item.id >= 100) {
                        filters.status_ = filter;
                    }
                    _this.setState({
                        filteredData: _this.filters(_data2, filters, false, _updatedRows)
                    });
                } else {
                    item.function({ data: _data2, meta: _meta2, params: _params2 });
                }
            } else if (props.menu === "cell-menu") {
                var _row = props.row,
                    _column = props.column;
                var _this$state4 = _this.state,
                    _data3 = _this$state4.data,
                    _meta3 = _this$state4.meta,
                    _params3 = _this$state4.params;

                item.function({ data: _data3, meta: _meta3, params: _params3, row: _row, column: _column });
            }
        }, _this.getCustomMenu = function (menu, menus) {
            if (_this.customContextualMenu && _this.customContextualMenu[menu]) {
                _this.customContextualMenu[menu].forEach(function (menu, index) {
                    return menus.push({
                        id: 1000000 + menus.length,
                        separation: index === 0 && menus.length > 0,
                        type: menu.type,
                        caption: menu.caption,
                        onClick: _this.handleClickMenu,
                        function: menu.function
                    });
                });
            }
        }, _this.getMenu = function (menu, data) {
            var menus = [];
            if (menu === "row-header-menu") {
                if (_this.state.meta.table.editable) {
                    menus.push({
                        id: menus.length,
                        type: "menu-item",
                        disable: !(data.status || {}).updated_,
                        separation: false,
                        caption: "Rollback row updates",
                        onClick: _this.handleClickMenu
                    });
                }
                if (_this.state.meta.row.audit) {
                    menus.push({
                        id: menus.length,
                        type: "menu-item",
                        disable: _this.state.auditedRow !== undefined,
                        // separation: false,
                        caption: "Audit",
                        onClick: _this.handleClickMenu
                    });
                }
            } else if (menu === "column-header-menu") {
                menus.push({
                    id: menus.length,
                    type: "menu-item",
                    disable: utils.isNullOrUndefined(_this.state.meta.lockedIndex),
                    separation: false,
                    caption: "Unlock columns",
                    onClick: _this.handleClickMenu
                });
                menus.push({
                    id: menus.length,
                    type: "menu-item",
                    separation: false,
                    caption: "Lock columns until " + data.column.caption,
                    onClick: _this.handleClickMenu
                });
            } else if (menu === "top-left-corner-menu") {
                if (_this.state.meta.table.editable) {
                    menus.push({
                        id: menus.length,
                        type: "menu-item",
                        checked: _this.state.filters.status_ === undefined,
                        caption: "No status filter",
                        onClick: _this.handleClickMenu
                    });
                    menus.push({
                        id: menus.length,
                        type: "sub-menu",
                        separation: menus.length > 0,
                        caption: "Status filters",
                        children: [{
                            id: 101,
                            type: "menu-item",
                            checked: (1 | (_this.state.filters.status_ || { v: 0 }).v) === (_this.state.filters.status_ || { v: 0 }).v,
                            // disable: utils.isNullOrUndefined(this.state.meta.lockedIndex),
                            separation: false,
                            caption: "Updated rows",
                            onClick: _this.handleClickMenu
                        }, {
                            id: 102,
                            type: "menu-item",
                            checked: (2 | (_this.state.filters.status_ || { v: 0 }).v) === (_this.state.filters.status_ || { v: 0 }).v,
                            separation: false,
                            caption: "New rows",
                            onClick: _this.handleClickMenu
                        }, {
                            id: 104,
                            type: "menu-item",
                            checked: (4 | (_this.state.filters.status_ || { v: 0 }).v) === (_this.state.filters.status_ || { v: 0 }).v,
                            separation: false,
                            caption: "Deleted rows",
                            onClick: _this.handleClickMenu
                        }, {
                            id: 108,
                            type: "menu-item",
                            // disable: utils.isNullOrUndefined(this.state.meta.lockedIndex),
                            checked: (8 | (_this.state.filters.status_ || { v: 0 }).v) === (_this.state.filters.status_ || { v: 0 }).v,
                            separation: false,
                            caption: "Rows with errors",
                            onClick: _this.handleClickMenu
                        }]
                    });
                }
                if (_this.state.meta.row.audit) {
                    menus.push({
                        id: menus.length,
                        type: "menu-item",
                        disable: _this.state.auditedRow === undefined,
                        separation: _this.state.meta.table.editable,
                        caption: "Close audit",
                        onClick: _this.handleClickMenu
                    });
                }
            }
            _this.getCustomMenu(menu, menus);
            if (menus.length) {
                return {
                    type: "menu",
                    position: "bottom",
                    children: menus
                };
            } else {
                return null;
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return TableMenu;
}(Component);


//////////////////
// WEBPACK FOOTER
// ./node_modules/zebulon-table/lib/Table.menu.js
// module id = 346
// module chunks = 0